export default __webpack_public_path__ + "static/media/Walker's Girdle of the Everlasting Sky.4e7ada4c.jpg";